import { render, staticRenderFns } from "./location-info-popup.vue?vue&type=template&id=a12b5516&scoped=true&lang=pug&"
import script from "./location-info-popup.vue?vue&type=script&lang=js&"
export * from "./location-info-popup.vue?vue&type=script&lang=js&"
import style0 from "./location-info-popup.vue?vue&type=style&index=0&id=a12b5516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12b5516",
  null
  
)

/* custom blocks */
import block0 from "./location-info-popup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "location-info-popup.vue"
export default component.exports